import { useApolloClient } from "@apollo/client";
import { Select } from "@cofano/cck";
import { useEffect } from "react";
import { CharterSubtype, CharterType } from "__generated__/enums";
import { GetContractsShortDocument } from "__generated__/view/contractsNew/graphql/contract.queries.generated";

export type CharterContractOption = {
	id: number;
	contractNumber: string;
	description: string;
};

const CharterContractSelect = ({
	onChange,
	value,
	additionalSearchOptions,
}: {
	onChange: (option?: CharterContractOption) => void,
	value?: CharterContractOption,
	additionalSearchOptions: {
		charterType?: CharterType,
		charterSubtypes?: CharterSubtype[],
		creditors?: number[],
		debtors?: number[],
		validOver?: {
			from: number,
			to: number,
		}
		locations?: number[],
		locationsOrEmpty?: number[],
	},
}) => {

	const client = useApolloClient();

	const onFetchOptionsPaginated = async(params: string, page: number) => {
		try  {

			const result = await client.query({
				query: GetContractsShortDocument,
				variables: {
					search: {
						contractNumber: params ? [ params ] : undefined,
						...additionalSearchOptions,
					},
					pagination: {
						page: page - 1,
						size: 5,
					},
				},
			});

			return {
				options: result.data.contracts?.content  as CharterContractOption[],
				totalResults: result.data.contracts?.totalElements || 0,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	const getDefaultContract = async() => {

		const result = await client.query({
			query: GetContractsShortDocument,
			variables: {
				search: additionalSearchOptions,
				pagination: {
					page: 0,
					size: 2,
				},
			},
		});

		if (result.data.contracts?.content?.length === 1) {
			onChange(result.data.contracts.content[0] as CharterContractOption);
		}
	};

	useEffect(() => {
		getDefaultContract();
	}, []);

	return (
		<Select
			fetchOptions={onFetchOptionsPaginated}
			paginated
			getOptionLabel={option => option.contractNumber || ""}
			value={value}
			onChange={option => onChange(option || undefined)}
			renderOption={(props, option) => (
				<li {...props}>
					<div style={{ width: "100%" }}>
						<div>
							{option.contractNumber}
						</div>
						<small style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", width: "100%" }}>
							{option.description}
						</small>
					</div>
				</li>
			)} />
	);
};

export default CharterContractSelect;
